import React, { useState } from 'react';
import './TagInput.css';

export const TextInput = (props) => {
  const [value, setValue] = useState(props.value || '');
  const [edit, setEdit] = useState(false);

  const onClick = () => {
    setValue(props.value || '');
    setEdit(true);
  };

  const onBlur = (e) => {
    setEdit(false);
    if (props.onBlur) props.onBlur(e);
  };

  if (!edit) {
    return (
      <div onClick={onClick} className="tag-input-display">
        <span>{props.value || '—'}</span>
        <span className="tag-input-edit-icon">&#10000;</span>
      </div>
    );
  }

  return (
    <input
      type="text"
      autoFocus
      value={value}
      onChange={e => setValue(e.target.value)}
      onBlur={onBlur}
      style={{ width: '100%', minWidth: 120 }}
    />
  );
};

export default TextInput;
